import { TableHeader, TableHead, TableRow } from "@/components/ui/table";

export function CostTableHeader() {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Cost Component</TableHead>
        <TableHead className="text-right">Budgeted</TableHead>
        <TableHead className="text-right">To Date</TableHead>
        <TableHead className="text-right">Forecast</TableHead>
        <TableHead className="text-right">Anticipated Final</TableHead>
        <TableHead className="text-right">Variance</TableHead>
        <TableHead className="text-right">Comments</TableHead>
      </TableRow>
    </TableHeader>
  );
}